export default __webpack_public_path__ + "static/media/OwlPage1.a62ca369.txt";